import React from 'react';

const Yale: React.FC<IHomePageCompanyLogoProps> = ({
  color,
  height = '32',
}) => {
  return (
    <svg
      width="58"
      height={height}
      viewBox={`0 0 58 ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M18.8494 10.2704L12.9735 20.1707V26.8305C13.6499 28.4329 15.3595 28.6464 16.9978 28.7178V29.6437H5.49474V28.7178C7.13298 28.6464 9.1273 28.3974 9.66141 27.3292V20.4556L3.67847 10.3415C2.64589 8.63205 1.64873 8.06251 -0.345703 7.9199V6.99405H9.66153V7.9199C7.77394 8.02663 7.16863 8.38305 6.63452 8.81056L12.1901 18.4256L17.6388 8.84586C17.069 8.41859 16.3212 8.02663 14.4337 7.92001V6.99416H22.9807V7.92001C21.0575 7.99132 19.8467 8.63205 18.8494 10.2704V10.2704ZM30.5303 29.9642C28.6074 29.9642 27.6813 28.6464 27.6101 27.7208C26.3992 29.0027 24.8325 29.9642 23.3367 29.9642C21.4136 29.9642 19.7753 28.7889 19.7753 26.7594C19.7753 25.7619 20.0246 24.7291 20.5233 23.9102L27.6101 21.346V18.7106C27.6101 17.1081 26.8622 15.5767 25.2596 15.5767C24.2981 15.5767 23.3722 16.7517 23.3011 18.5682L20.0957 19.1021V18.7464C21.164 15.5409 24.6899 14.2947 26.3991 14.2947C29.6399 14.2947 30.8151 16.0039 30.7795 18.6393L30.6728 26.1179C30.6372 27.5781 31.4205 27.9341 32.1329 27.9341C32.7025 27.9341 33.2723 27.5781 33.9492 26.9015V27.9341C33.1658 28.8603 31.777 29.9642 30.5303 29.9642V29.9642ZM23.4079 24.1594C23.2654 24.7291 23.1587 25.2277 23.1587 26.0112C23.1587 27.0795 23.7641 28.1477 24.9392 28.1477C26.0076 28.1477 26.613 27.792 27.5746 27.0439L27.6101 22.236C26.6843 22.6633 24.4052 23.6608 23.4079 24.1594V24.1594ZM34.2698 29.6437V28.8244C35.8723 28.7177 36.335 28.3616 36.6203 27.7559V9.30856C36.6203 8.09771 36.4421 7.59936 33.9848 7.38555V6.67339L40.5021 5.03516L40.7156 5.64093L39.683 6.92286V27.756C40.0391 28.4685 40.7156 28.7178 42.1758 28.8246V29.6438H34.2698V29.6437ZM50.7226 29.9286C46.9834 29.9286 44.0987 26.9727 44.0987 22.8416C44.0987 17.7845 47.1972 14.33 51.5776 14.33C55.1031 14.33 57.0618 16.3248 57.0618 19.4941V20.135L47.4464 20.0639C47.3754 20.4556 47.3394 21.0969 47.3394 21.8801C47.3394 25.5125 49.6187 27.8986 52.646 27.8986C54.462 27.8986 55.3882 27.2575 56.8124 26.0468L57.3466 26.8657C55.3169 28.7178 53.643 29.9286 50.7226 29.9286V29.9286ZM51.0435 15.4344C49.2625 15.4344 48.0165 16.8587 47.589 19.1021L53.8571 19.031C53.857 17.1435 52.6815 15.4344 51.0435 15.4344V15.4344Z"
          fill={`${color || 'white'}`}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="58"
            height={height}
            fill="white"
            transform="translate(0 3.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Yale;
